<template>
  <div class="cell city-cell"
    :class="{
      active: quiz.id === quizId,
      disabled: disabled
     }"
    @click="selectQuiz">
    {{quiz.name}}
    <div class="city-paper">{{quiz.examTypeName}}</div>
  </div>
</template>

<script>
export default {
  name: 'city-cell',
  props: ['quiz', 'quizId', 'majorId'],
  methods: {
    selectQuiz () {
      this.$emit('select')
    }
  },
  computed: {
    disabled () {
      const { quiz, majorId } = this
      if (majorId === 0) {
        return quiz.id !== 817 && quiz.id !== 855 && quiz.id !== 841
      } else if (majorId === 1 || majorId === 2) {
        return quiz.id === 817 || quiz.id === 855 || quiz.id === 841
      }
      return false
    }
  }
}
</script>

<style scoped>
.city-cell.active .city-paper {
  color: #FFF;
}
.city-cell {
  padding-top: 5px;
  box-sizing: border-box;
}
.city-cell.disabled {
  background: #f6f6f6;
  color: #CCC;
}
.city-cell.disabled .city-paper {
  color: #CCC;
}
.city-cell .city-paper {
  font-size: 11px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// CityCell.vue?452861c0